var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.27em",
    height: "1em",
    viewBox: "0 0 256 203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logosZod0",
    width: "105.2%",
    height: "106.5%",
    x: "-2.2%",
    y: "-2.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "logosZod1",
    fill: "#000",
    d: "M200.42 0H53.63L0 53.355l121.76 146.624l9.714-10.9L252 53.857zm-5.362 12.562l39.84 41.6l-112.8 126.558L17 54.162l41.815-41.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 1.51)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18253f",
    d: "M58.816 12.522h136.278l39.933 41.691l-112.989 126.553L16.957 54.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274d82",
    d: "M149.427 150.875H96.013l-24.124-29.534l68.364-.002l.002-4.19h39.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274d82",
    d: "M223.56 42.323L76.178 127.414l-19.226-24.052l114.099-65.877l-2.096-3.631l30.391-17.546zm-78.964-29.759L33.93 76.457L16.719 54.972l74.095-42.779z"
  }), /*#__PURE__*/React.createElement("use", {
    filter: "url(#logosZod0)",
    href: "#logosZod1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#3068b7",
    href: "#logosZod1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZod);
export default __webpack_public_path__ + "static/media/Zod.18e9de47f65962d222b77e9c1efe0a7c.svg";
export { ForwardRef as ReactComponent };